<p-toast></p-toast>
<p-confirmDialog header="Atenção" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-dialog [(visible)]="videoAberto" [modal]="true" header="Inserir vídeo" [style]="{ width: '28rem' }" appendTo="body">
  <div class="bh-campo">
    <label for="bhVideo">Link do vídeo</label>
    <input id="bhVideo" type="text" pInputText [(ngModel)]="linkDoVideo" placeholder="https://www.youtube.com/watch?v=…" (keyup.enter)="inserirVideo()" />
    <small class="bh-dica">YouTube, Vimeo ou Loom.</small>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" (click)="videoAberto = false"></button>
    <button pButton type="button" label="Inserir" (click)="inserirVideo()"></button>
  </ng-template>
</p-dialog>

<div class="bh">
  <div class="bh-topo">
    <div class="bh-titulo">
      <h1>News do <em>Hábil</em></h1>
      <p>Aqui a Haila publica novidades, correções, avisos, dicas e conteúdos de empreendedorismo. Os clientes leem tudo no News do Hábil.</p>
    </div>
    <button pButton type="button" class="p-button-outlined" label="Abrir o News" icon="pi pi-external-link" (click)="abrirBlog()"></button>
    <button pButton type="button" label="Novo post" icon="pi pi-plus" (click)="novoPost()"></button>
  </div>

  <p-progressBar *ngIf="carregando" mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar>

  <div class="bh-corpo">
    <section class="bh-lista" aria-label="Posts da Haila">
      <div class="bh-filtros">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input type="text" pInputText placeholder="Buscar na árvore" [(ngModel)]="busca" aria-label="Buscar na árvore" />
        </span>
      </div>

      <div class="bh-arvore" role="tree" aria-label="Posts por categoria">
        <button type="button" class="bh-pasta bh-raiz" role="treeitem" [attr.aria-expanded]="raizAberta || buscando" (click)="raizAberta = !raizAberta">
          <i class="pi bh-seta" [ngClass]="raizAberta || buscando ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          <i class="pi pi-folder bh-icone-pasta"></i>
          <span class="bh-pasta-nome">News do Hábil</span>
          <small>{{ contagem(totalNaArvore) }}</small>
        </button>

        <div class="bh-galhos" *ngIf="raizAberta || buscando" role="group">
          <button type="button" class="bh-no bh-no-novo" *ngIf="novo" aria-current="true" role="treeitem">
            <span class="bh-ponto bh-ponto-rascunho"></span>
            <span class="bh-no-titulo">{{ form?.titulo || 'Novo post' }}</span>
            <small>novo</small>
          </button>

          <div *ngFor="let g of arvore" class="bh-grupo">
            <button type="button" class="bh-pasta" role="treeitem" [attr.aria-expanded]="pastaAberta(g.categoria)" (click)="alternarPasta(g.categoria)">
              <i class="pi bh-seta" [ngClass]="pastaAberta(g.categoria) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              <i class="pi pi-folder bh-icone-pasta" [ngClass]="'bh-cor-' + g.categoria"></i>
              <span class="bh-pasta-nome">{{ plurais[g.categoria] }}</span>
              <small>{{ contagem(g.posts.length) }}</small>
            </button>
            <div *ngIf="pastaAberta(g.categoria)" role="group">
              <button type="button" class="bh-no" role="treeitem" *ngFor="let p of g.posts" [attr.aria-current]="!novo && p.id === editando?.id"
                [title]="rotuloStatus(status(p)) + ' · ' + (p.publicarEm | date: 'dd/MM/yyyy HH:mm')" (click)="selecionar(p)">
                <span class="bh-ponto" [ngClass]="'bh-ponto-' + status(p)"></span>
                <span class="bh-no-titulo">{{ p.titulo }}</span>
                <i *ngIf="p.destaque" class="pi pi-bookmark-fill bh-no-destaque" title="Destaque na fala da Haila"></i>
              </button>
              <div class="bh-no-vazio" *ngIf="!g.posts.length">Nenhum post ainda.</div>
            </div>
          </div>

          <div class="bh-vazio" *ngIf="buscando && !arvore.length">Nada encontrado para “{{ busca }}”.</div>
        </div>
      </div>

      <div class="bh-legenda">
        <span><i class="bh-ponto bh-ponto-publicado"></i>Publicado</span>
        <span><i class="bh-ponto bh-ponto-agendado"></i>Agendado</span>
        <span><i class="bh-ponto bh-ponto-rascunho"></i>Rascunho</span>
      </div>
    </section>

    <section class="bh-form" *ngIf="form">
      <div class="bh-form-topo">
        <h2>{{ novo ? 'Novo post' : 'Editar post' }}</h2>
        <span class="bh-status" [ngClass]="'bh-status-' + statusAtual">{{ rotuloStatus(statusAtual) }}</span>
      </div>

      <div class="bh-campo">
        <label for="bhTitulo">Título</label>
        <input id="bhTitulo" type="text" pInputText maxlength="200" [(ngModel)]="form.titulo" placeholder="Ex.: Compare períodos direto no Dashboard" />
      </div>

      <div class="bh-linha">
        <div class="bh-campo">
          <label for="bhCategoria">Categoria</label>
          <p-dropdown inputId="bhCategoria" [options]="categorias" [(ngModel)]="form.categoria" optionLabel="label" optionValue="value"
            appendTo="body" styleClass="bh-dropdown"></p-dropdown>
        </div>
        <div class="bh-campo" *ngIf="comMudancas">
          <label for="bhVersao">Versão</label>
          <input id="bhVersao" type="text" pInputText maxlength="30" [(ngModel)]="form.versao" placeholder="10.1.2.0" />
        </div>
        <div class="bh-campo">
          <label for="bhData">Publicação</label>
          <p-calendar inputId="bhData" [(ngModel)]="form.publicarEm" [showTime]="true" hourFormat="24" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
          <small class="bh-dica">Data futura vira agendamento: o post aparece sozinho nesse dia e hora.</small>
        </div>
      </div>

      <div class="bh-autora">
        <img [src]="imagemHaila" alt="" />
        <span>Quem assina é a <b>Haila</b>, do time Hábil.</span>
      </div>

      <div class="bh-campo">
        <label for="bhResumo">Resumo <small class="bh-dica">aparece na lista, no sino de recados e na fala da Haila</small></label>
        <textarea id="bhResumo" pInputTextarea rows="2" maxlength="300" [(ngModel)]="form.resumo"></textarea>
        <small class="bh-contador">{{ form.resumo.length }}/300</small>
      </div>

      <div class="bh-campo">
        <label>Texto <small class="bh-dica">títulos viram o “Neste post” e listas numeradas viram checklist para o leitor</small>
          <small class="bh-dica" *ngIf="enviandoImagem"> · enviando imagem…</small></label>
        <p-editor [(ngModel)]="form.texto" [style]="{ height: '22rem' }" placeholder="Escreva o post…" styleClass="bh-editor"
          (onInit)="aoIniciarEditor($event)">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <select class="ql-header" aria-label="Estilo do parágrafo">
                <option value="2">Título</option>
                <option value="3">Subtítulo</option>
                <option selected></option>
              </select>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Negrito"></button>
              <button type="button" class="ql-italic" aria-label="Itálico"></button>
              <button type="button" class="ql-underline" aria-label="Sublinhado"></button>
              <button type="button" class="ql-strike" aria-label="Tachado"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-list" value="ordered" aria-label="Lista numerada"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Lista com marcadores"></button>
              <button type="button" class="ql-blockquote" aria-label="Citação"></button>
              <button type="button" class="ql-code-block" aria-label="Código"></button>
              <select class="ql-aviso" aria-label="Bloco de aviso">
                <option selected></option>
                <option *ngFor="let tipo of tiposDeAviso" [value]="tipo.value">{{ tipo.label }}</option>
              </select>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-link" aria-label="Link"></button>
              <button type="button" class="ql-image" aria-label="Imagem"></button>
              <button type="button" class="ql-video" aria-label="Vídeo"></button>
              <button type="button" class="ql-clean" aria-label="Limpar formatação"></button>
            </span>
          </ng-template>
        </p-editor>
      </div>

      <div class="bh-linha" *ngIf="comMudancas">
        <div class="bh-campo" *ngFor="let g of grupos">
          <label [for]="'bhGrupo' + g.chave">{{ g.label }} <small class="bh-dica">um item por linha</small></label>
          <textarea [id]="'bhGrupo' + g.chave" pInputTextarea rows="4" [(ngModel)]="form[g.chave]" placeholder="**Tela**: o que mudou"></textarea>
        </div>
      </div>

      <div class="bh-enquete">
        <div class="bh-enquete-topo"><i class="pi pi-chart-bar"></i> Enquete <small class="bh-dica">opcional: o leitor vota e vê o resultado na hora</small></div>
        <div class="bh-linha">
          <div class="bh-campo">
            <label for="bhEnqPergunta">Pergunta</label>
            <input id="bhEnqPergunta" type="text" pInputText maxlength="200" [(ngModel)]="form.enquetePergunta" placeholder="Ex.: Você já usa a Curva ABC?" />
          </div>
          <div class="bh-campo">
            <label for="bhEnqOpcoes">Opções <small class="bh-dica">uma por linha, de 2 a 6</small></label>
            <textarea id="bhEnqOpcoes" pInputTextarea rows="4" [(ngModel)]="form.enqueteOpcoes" placeholder="Sim, toda semana&#10;De vez em quando&#10;Ainda não"></textarea>
          </div>
        </div>
        <div class="bh-enquete-res" *ngIf="!novo && editando?.enquete?.opcoes?.length && totalVotosEnquete">
          <div *ngFor="let o of editando.enquete.opcoes" class="bh-enquete-op">
            <span>{{ o.texto }}</span><b>{{ percentual(o.votos) }}% · {{ o.votos || 0 }}</b>
            <i><b [style.width.%]="percentual(o.votos)"></b></i>
          </div>
          <small class="bh-dica">{{ totalVotosEnquete }} {{ totalVotosEnquete === 1 ? 'voto' : 'votos' }}. Mudar o texto de uma opção zera os votos dela.</small>
        </div>
      </div>

      <div class="bh-check">
        <p-checkbox inputId="bhDestaque" [(ngModel)]="form.destaque" [binary]="true"></p-checkbox>
        <label for="bhDestaque">Destacar na fala da Haila (para avisos importantes)</label>
      </div>

      <div class="bh-nota">
        O cliente só vê posts <b>publicados</b> com data de hoje ou anterior. Rascunhos e agendados ficam só aqui.
      </div>

      <div class="bh-rodape" *ngIf="!novo && editando">
        <span *ngIf="editando.criadoPor">Criado por {{ editando.criadoPor }} em {{ editando.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</span>
        <span *ngIf="editando.alteradoPor"> · alterado por {{ editando.alteradoPor }} em {{ editando.alteradoEm | date: 'dd/MM/yyyy HH:mm' }}</span>
        <span *ngIf="statusAtual === 'publicado'"> · <i class="pi pi-thumbs-up"></i> {{ editando.votosSim }} acharam útil, <i class="pi pi-thumbs-down"></i> {{ editando.votosNao }} não</span>
        <div class="bh-reacoes" *ngIf="statusAtual === 'publicado' && totalReacoes">
          Reações:
          <span *ngFor="let r of reacoes" class="bh-reacao" [title]="r.label">{{ r.emoji }} {{ reacao(r.chave) }}</span>
        </div>
      </div>

      <div class="bh-acoes">
        <button pButton type="button" class="p-button-outlined p-button-secondary" label="Salvar rascunho" [disabled]="salvando" (click)="salvar('rascunho')"></button>
        <button pButton type="button" [label]="dataFutura ? 'Agendar' : 'Publicar'" [icon]="dataFutura ? 'pi pi-calendar' : 'pi pi-send'" [disabled]="salvando"
          (click)="salvar('publicado')"></button>
        <button pButton type="button" class="p-button-outlined p-button-secondary" label="Ver no News" icon="pi pi-external-link"
          *ngIf="!novo && statusAtual === 'publicado'" (click)="abrirBlog(editando.id)"></button>
        <span class="bh-espaco"></span>
        <button pButton type="button" class="p-button-text p-button-danger" label="Excluir" icon="pi pi-trash" *ngIf="!novo && editando" (click)="excluir()"></button>
      </div>
    </section>
  </div>
</div>
